import React,{Component} from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import NotFinishedPage from '../FunctionArea/NotFinishedPage'
  
  const useStyles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      padding: theme.spacing(1),
    },
    paper: {
      padding: theme.spacing(1),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },

    rowPaper: {
      //padding: theme.spacing(1),
      display: 'flex',
      overflow: 'auto',
    },

    fixedHeight: {
      height: '80vh',
    },
    button: {
      margin:theme.spacing(1),
      //padding: theme.spacing(1),
      fontFamily:'Microsoft JhengHei',
    },
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    rightIcon: {
      marginLeft: theme.spacing(1),
    },
    iconSmall: {
      fontSize: 20,
    },
  });

  class TrafficManagementBody extends Component {

    componentDidMount(){
      if(this.props.userID)
      {
        this.sessionCheck()
      }
      this.props.getCurrentModule("TrafficManagement")
      
      window.addEventListener("beforeunload",(e)=>{ 
        e.preventDefault()    
        return this.freeTrafficManagementSession()
      })
    }

    componentWillUnmount(){
      window.removeEventListener("beforeunload", this.freeTrafficManagementSession())
    }

    sessionCheck=()=>{
    }

    freeTrafficManagementSession=()=>{
    }
  

    render(){
      const {classes} = this.props
      //const buttonPaper = clsx(classes.rowPaper);
      const flexHeightPaper = clsx(classes.paper);

    return (

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth={false} className={classes.container}>
            <Grid container spacing={1}>        
              <Grid item xs={12}>
                <Paper className={flexHeightPaper}>
                  <NotFinishedPage type={1}/>
                </Paper>
              </Grid>              
            </Grid>
          </Container>
        </main>
      )
    }
  }

export default withStyles(useStyles)(TrafficManagementBody)